<template>
  <div v-if="feeConfiguration">
    <Details :feeConfiguration="feeConfiguration" @feeConfigUpdated="handleFeeConfigUpdate" />
    <FeeRanges :feeConfiguration="feeConfiguration" :url="url" />
  </div>
</template>
<script>
import Details from "./details.vue";
import FeeRanges from "../../generalLayouts/feeRanges/Index.vue";

export default {
  components: {
    Details,
    FeeRanges,
  },
  props: {
    id: {
      required: true,
    },
    feeConfigurationId: {
      required: true,
    },
  },
  data() {
    return {
      feeConfiguration: undefined,
    };
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    url() {
      return `api/v1/transactions/countryDepositConfig/${this.feeConfiguration.id}/fees`;
    },
  },
  methods: {
    async fetchData() {
      await this.$http
        .get(
          `api/v1/transactions/feeConfigurations/${this.feeConfigurationId}/countryDeposit/${this.id}`,
        )
        .then((data) => {
          this.feeConfiguration = data;
        });
    },
    handleFeeConfigUpdate() {
      this.fetchData();
    },
  },
};
</script>
